/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IReply } from 'src/interfaces';
import SupportDeskService from 'src/services/support-desk.service';

export const useAddSupportTicket = (): UseMutationResult<any, Error, { ticket: FormData }, void> =>
  useMutation((data: { ticket: FormData }) => SupportDeskService.addSupporTicket(data.ticket), {
    onSuccess: () => {
      AlertAdapter('Your ticket has been submitted. You will be contacted by the Support Desk shortly.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useAddSupportTicketReply = (): UseMutationResult<
  any,
  Error,
  { ticketId: string; ticket: FormData },
  void
> =>
  useMutation(
    ({ ticketId, ticket }: { ticketId: string; ticket: FormData }) =>
      SupportDeskService.addSupporTicketReply(ticketId, ticket),
    {
      onSuccess: () => {
        AlertAdapter('Reply Succefully Sent', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useReopenticket = (): UseMutationResult<any, Error, { ticketId: string; ticket: IReply }, void> =>
  useMutation(
    ({ ticketId, ticket }: { ticketId: string; ticket: IReply }) => SupportDeskService.reopenTicket(ticketId, ticket),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );
